import { Grid, GridItem, Label1 } from '@sainsburys-tech/fable'
import moment from 'moment'
import React from 'react'

import { IBatchTemperature } from '../../types/IBatchTemperature'
import {
  getRequiredTemperatureCount,
  isBatchDisposed,
} from '../../utils/hotFoodUtils'
import TemperatureCheckRow from './TemperatureCheckRow'

moment.locale('en-GB')

interface IProps {
  batch: IBatchTemperature
  temperatureCount: number
}

const TemperatureCheck = (props: IProps) => {
  const count = getRequiredTemperatureCount(props.batch)

  const temperatures = props.batch.temperatures!.slice(
    props.temperatureCount * count,
    props.temperatureCount * count + count,
  )

  return (
    <Grid>
      <GridItem data-testid='temperature-check-info' colSpan={12}>
        <Label1>
          {`${
            temperatures.filter((x) => x.isBluetoothReading === true).length > 0
              ? 'Bluetooth'
              : 'Manual'
          } ${
            props.temperatureCount === 0 ? 'temperature ' : 'boost temperature '
          }`}
          checks by {temperatures[0].takenBy!} at{' '}
          {moment.utc(temperatures[0].takenAt).local().format('H:mm')}
        </Label1>
      </GridItem>
      <GridItem colSpan={12}>
        <TemperatureCheckRow temperatures={temperatures} />
      </GridItem>

      {props.temperatureCount === 2 && isBatchDisposed(props.batch) && (
        <GridItem colSpan={12}>
          <Label1>{`${temperatures[0].takenBy!} told to dispose of batch and log faulty oven
            at ${moment.utc(temperatures[0].takenAt).local().format('H:mm')}`}</Label1>
        </GridItem>
      )}
    </Grid>
  )
}

export default TemperatureCheck
